import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { optionsEmailVerificado, optionsEstado, optionsUsuarios } from "../../../../constantes/constantes";
import { Download } from "lucide-react";


function FitroAtcComponents({
    name, handleName, cedula, handleCedula, estado, handleEstado,
    apellido, handleApellido, items, handleItems,
    userTester, handleUserTester, fechaInicio, handleFechaInicio,
    fechaFin, handleFechaFin
}) {

    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const formatDateInputValue = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value.slice(0, 10);
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return value.toISOString().split("T")[0];
        }
        return "";
    };

    const handleDateValue = (value, onChange) => {
        if (!value) return;
        const date = new Date(`${value}T00:00:00`);
        if (!Number.isNaN(date.getTime())) {
            onChange(date);
        }
    };

    const autocompleteSx = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f5f9',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
        },
    };

    const getOptionText = (option) => {
        if (typeof option === "string") return option;
        if (!option) return "";
        return option.label || option.value || "";
    };

    const getAutocompleteValue = (options, current) => {
        if (!current) return null;
        if (typeof current === "string") {
            return options.find((opt) => getOptionText(opt) === current) || current;
        }
        return current;
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6 mb-6">
            <div className="flex items-center justify-between gap-4">
                <h2 className="text-xl font-semibold text-gray-800">Historial de las Transacciones</h2>

                <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-lg bg-[#104063] px-4 py-2 font-semibold text-white transition-colors hover:bg-[#0d3553]"
                >
                    <Download className="w-4 h-4" />
                    Exportar
                </button>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Nombre</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => handleName(e.target.value)}
                        placeholder="Buscar por nombre"
                        autoCapitalize="none"
                        autoCorrect="off"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Apellido</label>
                    <input
                        type="text"
                        value={apellido}
                        onChange={(e) => handleApellido(e.target.value)}
                        placeholder="Buscar por apellido"
                        autoCapitalize="none"
                        autoCorrect="off"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Cédula</label>
                    <input
                        type="text"
                        value={cedula}
                        onChange={(e) => handleCedula(e.target.value)}
                        placeholder="Buscar por cédula"
                        autoCapitalize="none"
                        autoCorrect="off"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Estado</label>
                    <Autocomplete
                        disablePortal
                        freeSolo
                        options={optionsEstado}
                        value={getAutocompleteValue(optionsEstado, estado)}
                        getOptionLabel={getOptionText}
                        isOptionEqualToValue={(option, value) => {
                            if (typeof value === "string") return getOptionText(option) === value;
                            return option?.id === value?.id;
                        }}
                        onInputChange={(event, newInputValue) => {
                            handleEstado(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione" size="small" sx={autocompleteSx} />
                        )}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Items</label>
                    <Autocomplete
                        disablePortal
                        freeSolo
                        options={optionsEmailVerificado}
                        value={getAutocompleteValue(optionsEmailVerificado, items)}
                        getOptionLabel={getOptionText}
                        isOptionEqualToValue={(option, value) => {
                            if (typeof value === "string") return getOptionText(option) === value;
                            return option?.id === value?.id;
                        }}
                        onInputChange={(event, newInputValue) => {
                            handleItems(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione" size="small" sx={autocompleteSx} />
                        )}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha de inicio</label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaInicio)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaInicio)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha de fin</label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaFin)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaFin)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Usuarios</label>
                    <Autocomplete
                        disablePortal
                        freeSolo
                        options={optionsUsuarios}
                        value={getAutocompleteValue(optionsUsuarios, userTester)}
                        getOptionLabel={getOptionText}
                        isOptionEqualToValue={(option, value) => {
                            if (typeof value === "string") return getOptionText(option) === value;
                            return option?.id === value?.id;
                        }}
                        onInputChange={(event, newInputValue) => {
                            handleUserTester(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione" size="small" sx={autocompleteSx} />
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

export default FitroAtcComponents;